import { Component, OnInit } from "@angular/core";
import { UI } from "../../services/ui.service";

@Component({
  selector: "error",
  template: "",
})
export class ErrorComponent implements OnInit {
  constructor(private ui: UI) {}

  ngOnInit(): void {
    this.ui.notify(this.ui.EVENTS.ShowAlert, {
      title: "Server Connectivity!",
      message: "It's a shame but something had happen. Please reload the App!",
    });
  }
}
